<template>
	<div class="home">
		<header-component type="home" />
		<p class="title">Ваш AI-помощник!</p>
		<tag-list />
		<text-input
			v-if="!hideApp"
			:textMessage="message"
			@send-message="createNewThread"
			@button-secret-handler="toggleSecretChat"
			additionalClass="text-input--home"
		/>
		<!-- <teleport to="body">
			<div v-show="!hideApp" v-if="!authStore.isAuthenticated" class="menu-item-wrap">
				<profile-menu-item text="Условия обработки персональных данных" link="/privacy-policy" />
				<profile-menu-item text="Пользовательское соглашение" link="/eula" />
			</div>
		</teleport> -->
	</div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useThreadStore } from '@/stores/thread'
import { useCommonStore } from '@/stores/common'
import { useCookiesStore } from '@/stores/cookies'
import { useFeatureGate } from '@/composables/useFeatureGate'
import TagList from '@/components/TagList.vue'
import TextInput from '@/components/TextInput.vue'
import HeaderComponent from '@/components/HeaderComponent.vue'

const router = useRouter()
const threadStore = useThreadStore()
const commonStore = useCommonStore()
const cookiesStore = useCookiesStore()
const { checkResource, runResourceGate } = useFeatureGate()
const message = ref('')
const secretMode = computed(() => threadStore.secretMode)
const hideApp = computed(() => commonStore.hideApp)

function toggleSecretChat() {
	threadStore.toggleSecretChat()
}

async function createNewThread(message: string) {
	// Гейт — до clearProccess и до навигации, чтобы отказ не ломал текущее состояние.
	// Ресурс всегда text: свободный текст с главной создаёт текстовый тред, а тип топика
	// здесь остался бы от предыдущего треда (его сбрасывает clearProccess ниже).
	if (!runResourceGate(checkResource('text'), 'text')) return

	commonStore.disableLoading()
	await threadStore.clearProccess()
	commonStore.enableSendingMessage()
	threadStore.createMockMessage(message)
	threadStore.createThread({ promt: message })
	if (secretMode.value) {
		router.push(`/thread-secret`)
	} else {
		router.push(`/thread`)
	}
}

onMounted(() => {
	commonStore.disableSendingMessage()
	commonStore.disableLoading()
	cookiesStore.checkAndShowCookiesDialog()
})
</script>

<style lang="scss" scoped>
.title {
	font: var(--font-display);
	@if $is-mts {
		font: var(--font-heading);
	}
	text-align: center;
	margin-bottom: 24px;
}

.home {
	@if $is-mts {
		// z-index: 0 делает .home собственным контекстом наложения,
		// иначе ::before с z-index: -1 уходит за белый фон предков и не виден.
		position: relative;
		z-index: 0;
		// Фон-градиент: position: fixed — привязан к вьюпорту (как шапка и инпут),
		// поэтому не скроллится и не обрезается снизу на узких экранах.
		// top: 120px — ниже заголовка (шапка 56 + margin 24 + заголовок ~40),
		// на ~16px выше карточек, чтобы серое не начиналось от заголовка.
		// 110px продублирован в TextInput.vue (.text-input--home) — менять синхронно.
		&::before {
			content: '';
			position: fixed;
			top: 110px;
			left: 0;
			right: 0;
			bottom: 0;
			background: var(--gradient-home);
			z-index: -1;
			pointer-events: none;
		}
	}
}

.menu-item-wrap {
	position: fixed;
	bottom: 0;
	width: 100%;
	background-color: var(--background-primary);
	@include flex-column-start;
	padding-top: 24px;
	& * {
		margin-bottom: 8px;
	}
}
</style>
